import { useEffect, useState } from 'react';
import Loading from '../../Loading/Loading';
import { openModalBase } from '../../../utils/modals';
import ContentQualtricsSurvey from '../../Surveys/thirdPartySurveys/Satisfaction/Qualtrics/Content';
import EventService from '../../../services/events/EventService';
import { SURVEY_BASE_URL } from '../../../constants';
import SurveyHomeService from '../../../services/Qualtrics/Home';
import Dates from '../../../utils/dates';

const ModalHomeSatisfactionSurvey = ({ onClose, getIFrameUrl }) => {
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const endOfSurvey = (e) => {
      if (e.origin === SURVEY_BASE_URL && e.data === 'endOfSurvey') {
        SurveyHomeService.setLastQualtricsSurveyResponse(Dates.get().toDate());
      }
    };

    EventService.on('message', endOfSurvey);

    const handleClose = () => {
      onClose();
      EventService.remove('message', endOfSurvey);
    };

    (async () => {
      setLoading(true);
      try {
        const iframeUrl = await getIFrameUrl();
        openModalBase({
          title: 'Encuesta de satisfacción',
          close: handleClose,
          children: (close) => <ContentQualtricsSurvey close={close} url={iframeUrl} />,
        });
      } catch (error) {
      } finally {
        setLoading(false);
      }
    })();

    return () => {
      EventService.remove('message', endOfSurvey);
    };
  }, []);

  return loading && <Loading />;
};

export default ModalHomeSatisfactionSurvey;
